import { ChangeEvent } from 'react';
import classNames from 'classnames';
import { IProductV4ModifierOption, IProductV4Size } from 'src/types/product';
import { localeStore } from 'src/mobx/localesStore';
import { getTranslate } from 'src/utils/helpers';
import './style.scss';
import Input from 'src/view/components/Controls/Input/Input';
import { modalStore } from '~/mobx/modalStore';

interface IProps {
  name: string;
  isTaker360Enabled?: boolean | undefined;
  details: IProductV4Size[] | IProductV4ModifierOption[];
  isDisabledPriceChange?: boolean;
  showSeparator?: boolean;
  isFirstElement?: boolean;
  modifierName?: string;
}

const ItemDetailsTable = ({
  name,
  details,
  modifierName,
  isTaker360Enabled,
  isDisabledPriceChange,
  showSeparator,
  isFirstElement,
}: IProps): JSX.Element => {
  const onInputValueChange = (event: ChangeEvent<HTMLInputElement>, id?: number) => {
    modalStore.onModifierPriceChange?.(event.target.value, id);
  };

  return (
    <div className={classNames('d-flex flex-column flex-1 mb-3', { 'border-bottom': showSeparator })}>
      {isFirstElement && (
        <div className="d-flex flex-row my-4">
          {modifierName && <h3 className="item-details-table__heading modifier">{localeStore.t('modifier_name')}</h3>}
          <h3 className="item-details-table__heading option">{name}</h3>
          <h3 className="item-details-table__heading price">{localeStore.t('price')}</h3>
          {isTaker360Enabled && <h3 className="item-details-table__heading mb-2 taker360">{localeStore.t('taker360_price')}</h3>}
        </div>
      )}
      <div className="d-flex flex-row">
        <div className="w-100">
          {details.map((detail, index) => (
            <div key={detail.id} className={classNames('d-flex align-items-center', { 'mb-2': isTaker360Enabled, 'mb-4': !isTaker360Enabled })}>
              {modifierName && (
                <div className="family-medium text-elipsis overflow-hidden text-size-16 modifier pr-4">{index === 0 ? modifierName : ''}</div>
              )}
              <div className={classNames('content-container', { 'content-container-taker-360': isTaker360Enabled })}>
                <div className="d-flex align-items-center">
                  <p className="family-medium text-elipsis overflow-hidden text-size-16 pr-4 option">{getTranslate(detail.name)}</p>
                  <p className="family-semibold text-size-16 item-detail pr-4 price">{detail.price}</p>
                  {isTaker360Enabled && (
                    <div className="taker360">
                      <Input
                        className="menu-group-items-list-row__price input"
                        value={detail.menu_group_price ?? detail.price}
                        disabled={isDisabledPriceChange}
                        onChange={(value) => onInputValueChange(value, detail.id)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ItemDetailsTable;
